<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-07-19 09:31:46
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2022-07-21 10:58:39
-->
<template>
  <div class="word privacy_policy p-t-100 p-b-50">
    <div class="word-title">{{$t('privacyPolicy.title')}}</div>
    <div class="word-main">
      <div class="word-main-list" v-for="(item,index) in $t('privacyPolicy.list')" :key="index">
        <div class="title"><span v-html="item.title"></span><i class="line center_left_right"></i></div>
        <div class="des" v-for="(list,i) in item.des" :key="i" v-html="list"></div>
      </div>
      <div>
        <div>{{$t('privacyPolicy.bottom')[0]}}</div>
        <div>{{$t('privacyPolicy.bottom')[1]}}</div>
        <div>{{$t('privacyPolicy.bottom')[2]}}</div>
        <div>{{$t('privacyPolicy.bottom')[3]}}</div>
        <div class="textr p-t-60 p-b-30">{{$t('privacyPolicy.time')}}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  }
}
</script>
